import type { SourceInfo } from 'plyr'

import Plyr, { type PlyrOptions } from 'plyr-react'
import 'plyr-react/plyr.css'

export type videoType = 'mp4' | 'url' | 'vimeo' | 'youtube'

export interface VideoPlayerProps {
  autoplay?: boolean
  hideControls?: boolean
  loop?: boolean
  muted: boolean
  ratio?: string
  thumbnail?: string
  videoType: videoType
  videoUrl?: string
  vimeoId?: string
  youtubeId?: string
}

function VideoPlayer({
  autoplay,
  hideControls,
  loop,
  muted,
  ratio,
  thumbnail,
  videoType,
  videoUrl = 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4',
  vimeoId = '347119375',
  youtubeId = 'yWtFb9L',
}: Readonly<VideoPlayerProps>) {
  const options: PlyrOptions = {
    autoplay,
    controls: ['play', 'mute'],
    fullscreen: { enabled: false },
    hideControls,
    loop: { active: loop },
    muted,
    ratio: ratio,
    storage: { enabled: false },
  }

  const videoSources = {
    default: { provider: 'html5', source: videoUrl },
    mp4: { provider: 'html5', source: videoUrl },
    vimeo: { provider: 'vimeo', source: vimeoId },
    youtube: { provider: 'youtube', source: youtubeId },
  }

  const { provider, source } = videoSources[videoType] || videoSources.default

  const src: SourceInfo = {
    poster: thumbnail,
    previewThumbnails: { src: thumbnail },
    sources: [{ provider, src: source }],
    type: 'video',
  }

  return (
    <div>
      <Plyr options={options} playsInline source={src} />
    </div>
  )
}

export default VideoPlayer
